import { addDays } from "date-fns";
import { filter, map, take } from "rxjs";

import { useQueryParams$ } from "../../../common/hooks/useQueryParams$";
import {
  getAttributeList,
  getDateAttribute,
} from "../../../common/searchParams.utils";
import { PaymentPaidSearch } from "./PaymentPaidSearch";
import { PaymentPaidTable } from "./PaymentPaidTable";

export const PaymentPaidResource = () => {
  const params$ = useQueryParams$().pipe(
    filter(() => {
      return (
        window.location.pathname ===
        "/web/importaciones/facturacion/pagos/facturados"
      );
    }),
    map((params: any) => {
      const volante_nums = getAttributeList(params.volante_nums);
      const from_date = getDateAttribute(params.from_date);
      const to_date = getDateAttribute(params.to_date, addDays(new Date(), 5));

      return {
        ...params,
        volante_nums,
        from_date,
        to_date,
      };
    })
  );
  return (
    <>
      <PaymentPaidSearch params$={params$.pipe(take(1))} />
      <PaymentPaidTable params$={params$} />
    </>
  );
};
